import { INACTIVITY_LIMIT } from '@/utils/constant';

// Time of the latest API response while signed in, shared by every tab
// (DGR-1835). Template ignores storage events for this key so it doesn't
// reload other tabs. Kept free of app imports so anything can use it.
export const LAST_ACTIVITY_KEY = 'last-activity-at';

export const getLastActivityAt = (): string | undefined => {
  try {
    return localStorage.getItem(LAST_ACTIVITY_KEY) ?? undefined;
  } catch {
    return undefined;
  }
};

export const recordActivity = () => {
  try {
    localStorage.setItem(LAST_ACTIVITY_KEY, new Date().toISOString());
  } catch {
    // Storage unavailable: the timer still works for this tab.
  }
};

export const idleForMs = (): number | undefined => {
  const lastActivityAt = Date.parse(getLastActivityAt() ?? '');
  return Number.isNaN(lastActivityAt) ? undefined : Date.now() - lastActivityAt;
};

/** True when the stored session has had no activity for the inactivity limit (e.g. the browser was closed). */
export const isSessionStale = () => {
  const idleFor = idleForMs();
  return idleFor !== undefined && idleFor >= INACTIVITY_LIMIT;
};

/** When an idle session timed out: last activity + the inactivity limit, never later than now. */
export const inactivityTimedOutAt = (): string | undefined => {
  const lastActivityAt = Date.parse(getLastActivityAt() ?? '');
  if (Number.isNaN(lastActivityAt)) return undefined;
  return new Date(Math.min(Date.now(), lastActivityAt + INACTIVITY_LIMIT)).toISOString();
};
